import React from 'react';
import CommunityViewNew from './CommunityViewNew';

/**
 * Variante D: tarjeta de horarios **abajo del todo, junto a la card de
 * Información** (ocupa el espacio que antes usaba "Acciones rápidas",
 * que se oculta en esta variante).
 *
 * URL: /communities4/:id
 */
export default function CommunityView4() {
  return <CommunityViewNew scheduleCardPlacement="bottom-with-info" />;
}
